import _slicedToArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useControlledState } from "@react-stately/utils";
/**
 * Manages state for an overlay trigger. Tracks whether the overlay is open, and provides
 * methods to toggle this state.
 */

export function useOverlayTriggerState(props) {
  var _useControlledState = useControlledState(props.isOpen, props.defaultOpen || false, props.onOpenChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      isOpen = _useControlledState2[0],
      setOpen = _useControlledState2[1];

  return {
    isOpen: isOpen,
    open: function open() {
      setOpen(true);
    },
    close: function close() {
      setOpen(false);
    },
    toggle: function toggle() {
      setOpen(!isOpen);
    }
  };
}